/**
 * 检查服务端请求是否为爬虫
 * @returns {boolean} 如果 header 中 n-spider 为 '1' 则返回 true，否则返回 false
 */
export const useSpider = () => {
  // 仅在服务端运行
  if (process.server) {
    try {
      const event = useRequestEvent();
      const headers = event?.node?.req?.headers || {};
      return headers['n-spider'] === '1';
    } catch (error) {
      console.error('useSpider error:', error);
      return false;
    }
  }
  // 客户端返回 false
  return false;
};
